import { useContext } from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AppContext } from "../App";
import { t } from "../i18n";
import { glassItems } from "../utils/symbols";
import { useWizardNavigation } from "../hooks/useWizardNavigation";

export const DamageGlassMoreInfo = () => {
	const { data, setData, isTransitioning } = useContext(AppContext);
	const { nextPage, previousPage } = useWizardNavigation();

	return (
		<>
			<Header />
			<Content
				data={data}
				setData={setData}
				isTransitioning={isTransitioning}
			/>
			<Footer nextPage={nextPage} previousPage={previousPage} />
		</>
	);
};

const Content = ({ data, setData, isTransitioning }) => {
	const match = glassItems.find((i) => i.glassName === data.damageGlass);
	const glassChildren = match?.glassChildren ?? [];

	const updateDamageGlassMoreInfo = (damageGlassMoreInfo) => () => {
		setData((prev) => ({
			...prev,
			damageGlassMoreInfo,
		}));
	};

	return (
		<div
			className={
				"content kensei_03" + (isTransitioning ? " fade-in" : "")
			}
		>
			<div className="content_damage_glass_more_info">
				<div className="content_title">
					<h2 className="select_damage_glass_more_info">
						<strong>{t("Indica el tipo de luna")}</strong>
					</h2>
				</div>
				<div className="damage_glass_more_info_options">
					{glassChildren.map((child, index) => (
						<div
							key={index}
							className={`damage_glass_more_info_option ${
								data.damageGlassMoreInfo === child.value
									? " selected"
									: ""
							} kensei_03`}
							onPointerDown={updateDamageGlassMoreInfo(
								child.value,
							)}
						>
							<img
								className="damage_glass_more_info_image"
								src={`${child.image}`}
								alt={t(child.description)}
							/>
							<div className="damage_glass_more_info_content">
								<p>{t(child.description)}</p>
								{child.description ===
								"Cristal pequeño de la puerta" ? (
									<span>
										{t(
											"Está en la puerta del vehículo",
										)}
									</span>
								) : child.description ===
								  "Cristal pequeño detrás de la puerta" ? (
									<span>
										{t(
											"Está en la estructura del vehículo",
										)}
									</span>
								) : null}
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
